import { IonAlert, IonButton, IonCol, IonGrid, IonIcon, IonRow } from '@ionic/react';
import { checkmarkCircle, checkmarkCircleOutline } from 'ionicons/icons';
import moment from 'moment';
import QRCodeCanvas from 'qrcode.react';
import React, { act, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getConfig } from '../../appConfig';
import AddToWallet from '../../components/addToWallet';
import { NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../../components/common';
import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { SubscriptionLine } from '../../components/subscription-item';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import {
  checkBackgroundColor,
  forwardTo,
  getDefaultRoute,
  isDefined,
  isEmptyObject,
  isWebConfig,
} from '../../lib/utils';
import {
  getSubscriptions,
  reactivateSubscription,
  unsubscribe,
} from '../../store/subscription/actions';
import './index.css';

const MyMembership = ({
  __,
  subscriptions,
  active_subscription,
  getSubscriptions,
  unsubscribe,
  reactivateSubscription,
  navConfig,
  clientProfile,
  clientStyles,
  profile,
  location
}) => {
  useEffect(() => {
    getSubscriptions();
  }, []);
  if (isEmptyObject(active_subscription)) {
    forwardTo('/membership');
  }
  const [showSwitchMembershipAlert, setShowSwitchMembershipAlert] = useState(false);
  const [showCancelMembershipAlert, setShowCancelMembershipAlert] = useState(false);
  const [showReactivatingMembershipAlert, setShowReactivatingMembershipAlert] = useState(false);

  const handleClick = (active_subscription) => () => {
    if (active_subscription.cancellation_pending) {
      setShowReactivatingMembershipAlert(true);
    } else {
      setShowCancelMembershipAlert(true);
    }
  };

  const cancelMembershipAction = () => {
    setShowCancelMembershipAlert(false);
    unsubscribe();
  };

  const reactivateMembershipAction = () => {
    setShowReactivatingMembershipAlert(false);
    reactivateSubscription();
  };


  const backHandler = () => {
    const defaultRoute = getDefaultRoute(navConfig);
    forwardTo(defaultRoute.path);
  };
  const { hasAddToAppleWallet, hasAddToGoogleWallet } = getConfig().flags;
  const subscriptionData = subscriptions.find((e) => e.id == active_subscription.id) || {
    image: '',
    description: ''
  }
  let logoColor = 'dark';

  if (clientStyles?.colors?.['--okx-loyalty-card-background']) {
    logoColor = checkBackgroundColor(clientStyles?.colors?.['--okx-loyalty-card-background'])
  }
  const logo_image = clientProfile.logo_image || ''
  const logo_image_light = clientProfile.logo_image_light || clientProfile.logo_image || ''
  return (
    <Loading transparent>
      <Layout
        showHamburger
        backHandler={backHandler}
        hideSecondToolbar={true}
        color="transparent"
        title={__('Your subscription')}
        headerWithTitle
      >

        <div className="absolute-content scrollable-y">
          {location?.state?.success &&
            <>
              <div className="box-content on-creating-success">
                <IonIcon icon={checkmarkCircle}></IonIcon>
                <div>
                  <StrongText className="block">{__('Subscription successful')}</StrongText>
                  <Spacer size={0} />
                  <SmallText>{`${__('Your subscription will renew on ')} ${moment(active_subscription.next_renewal_date).format('MM/DD')}`}</SmallText>
                </div>
              </div>
              <Spacer size={1} />
            </>
          }
          <div className='loyalty-header-with-image-wrapper'>
            <IonGrid className='loyalty-header'>
              <IonRow>
                <IonCol>
                  <img src={logoColor == 'white'?logo_image_light:logo_image} />
                </IonCol>

              </IonRow>
              <IonRow class='loyalty-card-image'>
                <img src={subscriptionData.image} />

              </IonRow>
              <IonRow>
                <IonCol>
                  <Subtitle className="bold">{active_subscription.package}</Subtitle>
                </IonCol>
              </IonRow>
              <IonRow className='centered qr-code-wrapper'>
                <QRCodeCanvas value={profile.qr_code} size={isWebConfig() ? 126 : 110} />
              </IonRow>
              <IonRow>
                <IonCol>
                  <Subtitle>
                    {Basket.formatPrice(active_subscription.package_cost / 100, true)}
                  </Subtitle>
                  <SmallText>{__('per month')}</SmallText>
                </IonCol>
                <IonCol class='righted'>
                  <Subtitle>{moment(active_subscription.next_renewal_date).format('MM/DD')}</Subtitle>
                  <SmallText>{active_subscription.cancellation_pending ? __('Ends on') : __('Renews on')}</SmallText>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
          <Spacer size={5} />
          {isDefined(profile.qr_code) &&
            profile.qr_code !== '' &&
            (hasAddToAppleWallet || hasAddToGoogleWallet) ? (
            <AddToWallet />
          ) : null}
          {!isWebConfig() &&
            <Spacer size={5} />

          }
          <div className='box-content'>
            <div style={{ display: 'grid', gap: 'var(--spacer-2)', gridAutoFlow: 'column', gridTemplateColumns: '25px 1fr' }}>
              <IonIcon style={{ height: '25px', width: '25px' }} color='success' icon={checkmarkCircle} />
              <StrongText>{__('Subscription active')}</StrongText>
            </div>
            <Spacer size={2} />
            <NormalText>{subscriptionData.description}</NormalText>
            {subscriptionData.perks?.length > 0 &&
              <>
                <Spacer size={2} />

                <div className="subscription-perks">
                  {subscriptionData.perks && subscriptionData.perks.map((el) => {
                    return (
                      <div>
                        <IonIcon icon={checkmarkCircle} color="primary" />
                        <NormalText>{__(el.name)}</NormalText>
                      </div>
                    );
                  })}
                </div>            </>

            }

          </div>

          <Spacer size={5} />
          <IonButton
            color={active_subscription.cancellation_pending ? 'secondary' : 'danger'}
            disabled={active_subscription === null}
            onClick={handleClick(active_subscription)}
            expand="block"
            fill={active_subscription.cancellation_pending ? 'solid' : 'clear'}
            className={'link'}
          >
            {active_subscription.cancellation_pending
              ? __('Cancellation Pending - Reactivate?')
              : __('Cancel subscription')}
          </IonButton>
        </div>

        <IonAlert
          isOpen={showSwitchMembershipAlert}
          header={__('Confirm Change')}
          message={__(
            'Are you sure you wish to change your membership? Your new package will start at the next scheduled renewal date.',
          )}
          buttons={[
            { text: __('Cancel'), handler: () => setShowSwitchMembershipAlert(false) },
            { text: __('OK'), handler: () => setShowSwitchMembershipAlert(false) },
          ]}
        />
        <IonAlert
          isOpen={showCancelMembershipAlert}
          header={__('Are you sure')}
          message={__('By cancelling your membership it will not renew on the scheduled date.')}
          buttons={[
            {
              text: __('Done'),
              handler: cancelMembershipAction,
              cssClass: 'primary'
            },
            {
              text: __('Cancel'),
              cssClass: 'link secondary',

              handler: () => setShowCancelMembershipAlert(false)
            },

          ]}
        />
        <IonAlert
          isOpen={showReactivatingMembershipAlert}
          header={__('Are you sure')}
          message={__(
            'By reactivating your membership it will renew on the scheduled renewal date.',
          )}
          buttons={[

            {
              text: __('Done'),
              handler: reactivateMembershipAction,
              cssClass: 'primary'

            },
            {
              text: __('Cancel'),
              cssClass: 'link secondary',
              handler: () => setShowReactivatingMembershipAlert(false),
            },
          ]}
        />
      </Layout>
    </Loading>
  );
};

const mapStateToProps = (store) => ({
  subscriptions: store.subscription.subscriptions,
  active_subscription: store.profile.profile.active_subscription,
  navConfig: store.common.navConfig,
  clientProfile: store.common.clientProfile,
  clientStyles: store.common.clientStyles,
  profile: store.profile.profile,
});

const mapDispatchToProps = {
  getSubscriptions,
  unsubscribe,
  reactivateSubscription,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(MyMembership));
